import React from 'react';
import ApplicationPerformanceScorecard from '@containers/ApplicationPerformanceRedesigned/ApplicationPerformanceStandardMetrics/ApplicationPerformanceScorecard';
import SummaryMetrics from '@containers/GlobalUserAdoption/SummaryMetrics';
import { OverviewComponentType, ProductOverviewRegistry } from '../../types';

interface ScorecardConfig {
  id: string;
  Component: OverviewComponentType;
}

const scorecardConfigs: ScorecardConfig[] = [
  {
    id: 'app-performance',
    Component: () => (
      <ApplicationPerformanceScorecard
        title="App Performance"
        showInfoIcon={true}
        isOverview={true}
      />
    ),
  },
  {
    id: 'user-adoption',
    Component: () => <SummaryMetrics title="User Adoption" />,
  },
];

const scorecards: OverviewComponentType[] = scorecardConfigs.map(
  (config) => config.Component
);

const customOverview: OverviewComponentType | null = null;

const ProfitToServeRegistry: ProductOverviewRegistry = {
  scorecards,
  customOverview,
};

/**
 * ProfitToServeOverview - React component for rendering ProfitToServe scorecards
 * Can be registered in customComponentRegistry for DatoCMS rendering
 */
export const ProfitToServeOverview: React.FC<{
  isCmsRender?: boolean;
}> = () => (
  <>
    {scorecardConfigs.map(({ id, Component }) => (
      <Component key={id} />
    ))}
  </>
);

export default ProfitToServeRegistry;
